const initAboutPage = () => {
    const aboutRoot = document.querySelector('.ifer-about');

    if (!aboutRoot) {
        return;
    }

    const applyTimelineClasses = () => {
        const timelineList = document.querySelector('.timeline-list');

        if (!timelineList) {
            return;
        }

        const timelineItems = timelineList.querySelectorAll(':scope > div');

        timelineItems.forEach((item, index) => {
            item.classList.add(index % 2 === 0 ? 'timeline-block-right' : 'timeline-block-left');
        });
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyTimelineClasses);
    } else {
        applyTimelineClasses();
    }
};

initAboutPage();
